// Salty design tokens — the single source of truth for the orange / beige / ink system.
//
// These live in their OWN module (not in App.tsx) deliberately: App.tsx imports every page
// at the top, and pages like Dashboard import `tokens`. If `tokens` were exported from App.tsx,
// that creates a circular import — App → Dashboard → App — and `tokens` is read before App's
// module body finishes initializing it, throwing "Cannot access 'tokens' before initialization"
// at runtime (a temporal-dead-zone error that the build/tsc do NOT catch). Keeping tokens in a
// leaf module with no imports back into App breaks the cycle.
export const tokens = {
  orange: '#DC5829',
  orangeLight: '#F26A2E',
  orangeDark: '#B8451E',
  beige: '#F1F2DA',
  surface: '#FFFFFF',
  ink: '#1A1410',
  muted: '#6B625B',
  border: '#ECECE4',
  heroGradient: 'linear-gradient(135deg,#1A1410 0%,#3A2A1E 100%)',
  orangeGlow: 'radial-gradient(60% 80% at 80% 0%, rgba(220,88,41,0.28) 0%, rgba(220,88,41,0) 70%)',
  drawerGradient: 'linear-gradient(180deg,#1A1410 0%,#2A211C 100%)',
  softShadow: '0 1px 2px rgba(26,20,15,0.04), 0 10px 28px rgba(26,20,15,0.05)',
} as const;
